import { Link } from "react-router-dom";

// Import device icons
import chrome from "../assets/icons/device/chrome.png";
import samsung from "../assets/icons/device/samsung.png";
import apple from "../assets/icons/device/apple.png";
import windows from "../assets/icons/device/Windows.png";
import firetv from "../assets/icons/device/firetv.png";
import androidtv from "../assets/icons/device/androidtv.png";
import x96 from "../assets/icons/device/x96.png";
import lg from "../assets/icons/device/lg.png";
import toshiba from "../assets/icons/device/toshiba.png";
import tcl from "../assets/icons/device/tcl.png";
import sharp from "../assets/icons/device/sharp.png";
import sony from "../assets/icons/device/sony.png";
import android from "../assets/icons/device/Android.png";
import xbox from "../assets/icons/device/xbox.png";
import formuler from "../assets/icons/device/formuler.png";
import lenovo from "../assets/icons/device/Lenovo.png";
import philips from "../assets/icons/device/philips.png";
import xiaomi from "../assets/icons/device/xiaomi.png";
import roku from "../assets/icons/device/roku.png";
import ps from "../assets/icons/device/ps.png";
import huawei from "../assets/icons/device/huawei.png";
import hisense from "../assets/icons/device/Hisense.png";
import vizio from "../assets/icons/device/VIZIO.png";
import nvidia from "../assets/icons/device/NVIDIA.png";

export default function Device() {
  const deviceLogos = [
    { name: "Chrome", src: chrome },
    { name: "Samsung", src: samsung },
    { name: "Apple", src: apple },
    { name: "Windows", src: windows },
    { name: "Fire TV", src: firetv },
    { name: "Android TV", src: androidtv },
    { name: "X96", src: x96 },
    { name: "LG", src: lg },
    { name: "Toshiba", src: toshiba },
    { name: "TCL", src: tcl },
    { name: "Sharp", src: sharp },
    { name: "Sony", src: sony },
    { name: "Android", src: android },
    { name: "Xbox", src: xbox },
    { name: "Formuler", src: formuler },
    { name: "Lenovo", src: lenovo },
    { name: "Philips", src: philips },
    { name: "Xiaomi", src: xiaomi },
    { name: "Roku", src: roku },
    { name: "PlayStation", src: ps },
    { name: "Huawei", src: huawei },
    { name: "Hisense", src: hisense },
    { name: "Vizio", src: vizio },
    { name: "NVIDIA", src: nvidia },
  ];

  return (
    <>
      <section className="py-12 sm:py-16 bg-slate-50 relative animated-bg">
        {/* Dotted background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "radial-gradient(circle, #64748b 1px, transparent 1px)",
              backgroundSize: "20px 20px",
            }}
          ></div>
        </div>

        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mx-auto font-black mb-3 sm:mb-4 max-w-3xl leading-snug text-center">
              Dispositivos{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                Compatibles
              </span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Transmite TV MARCA en tus dispositivos favoritos
            </p>
          </div>

          {/* Device Grid */}
          <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-8 gap-2 sm:gap-4 mb-8 sm:mb-12">
            {deviceLogos.map((device, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg sm:rounded-xl p-2 sm:p-4 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 border border-gray-100"
              >
                <div className="flex items-center justify-center h-8 sm:h-10">
                  <img
                    src={device.src}
                    alt={device.name}
                    className="max-h-8 sm:max-h-10 max-w-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <a
              href="#pricing"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl text-white font-bold text-base sm:text-lg shadow-lg bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 transition-all duration-300 transform hover:scale-105 min-h-[48px]"
            >
              VER NUESTROS PLANES
              <span className="ml-1 sm:ml-2 text-lg sm:text-xl">→</span>
            </a>
          </div>

          {/* Contextual links to the device guides (internal linking) */}
          <nav aria-label="Guías por dispositivo" className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-2 sm:gap-3">
            {[
              { to: "/iptv-smart-tv", label: "IPTV para Smart TV" },
              { to: "/iptv-android-tv", label: "IPTV para Android TV" },
              { to: "/iptv-fire-tv", label: "IPTV para Fire TV" },
              { to: "/iptv-movil", label: "IPTV en el móvil" },
              { to: "/iptv-ordenador", label: "IPTV en el ordenador" },
              { to: "/como-configurar-iptv", label: "Cómo configurar IPTV" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-gray-200 bg-white text-xs sm:text-sm font-semibold text-[#090979] shadow-sm hover:shadow-md hover:bg-slate-50 transition-all duration-300"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
